import { defineComponent as _defineComponent } from 'vue'
import { getSimpleCategory } from '@/api/ware/category';
import queryWare from '@/api/ware/management';
import { useForm } from '@/util/useForm';
import NCascader from '@/component/NForm/NCascader/NCascader.vue';
import { ref, watch, computed, onMounted } from 'vue';
import { formatDate } from '../../../../../util/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSelector',
  emits: ['add'],
  setup(__props, { emit }) {


const ware_category_list = ref<any[]>([]);
(async () => {
  const res = await getSimpleCategory();
  res.unshift({
    id: 0,
    name: '全部',
  });
  ware_category_list.value = res;
})();
const modalVisible = ref<boolean>(false);
const queryParams = ref<any>({});
const dataSource = ref<any[]>([]);
const pagination = ref<{
  current: number;
  total: number;
  pageSize: number;
  showTotal: () => string;
}>({
  current: 1,
  total: 0,
  pageSize: 20,
  showTotal: () => `共0条, 每页20条`,
});
const selectedRowKeys = ref<any[]>([]);
const selectedRow = ref<any[]>([]);

const form = useForm();
function openModal() {
  modalVisible.value = true;
}
function ok() {
  emit('add',selectedRow.value)
  modalVisible.value = false
}
async function query(params = queryParams.value) {
  const res = await queryWare(params.current, { ...params, filter_promotion_product: 1 });
  dataSource.value = res.detail;
  pagination.value = {
    current: Number(res.current),
    total: Number(res.total),
    pageSize: Number(res.limit),
    showTotal: () => `共${res.total}条, 每页${res.limit}条`,
  };
}
onMounted(() => {
  query();
});
//表单提交
function submit(e) {
  if(!form.value) return
  //移除表单提交默认事件
  // e.preventDefault();
  const formdata = form.value.getFormValue();
  queryParams.value = {
    ...queryParams.value,
    current: 1,
    ...formdata,
  };
  query();
}
//重置表单
function clearForm() {
  form.value.resetFields();
  queryParams.value = { current: 1 };
  query();
}

function onPagination(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  queryParams.value = {
    ...queryParams.value,
    current: page.current,
  };
  query();
}
function onSelect(val,row) {
  selectedRowKeys.value = val;  
  selectedRow.value = row.map((item)=>{
    return {
      ...item,
        price:item.price,
        sort:0,
        product_id:item.id
    }
  })
}

watch(modalVisible, () => {
  if (modalVisible.value == true) {
    selectedRowKeys.value = [];
    query();
  }
});

return { __sfc: true,emit, ware_category_list, modalVisible, queryParams, dataSource, pagination, selectedRowKeys, selectedRow, form, openModal, ok, query, submit, clearForm, onPagination, onSelect, NCascader, formatDate }
}

})